// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Fvte","title":"Info_title__2njPS","links":"Info_links__PzU1o","link":"Info_link__Dy-JT","logo":"Info_logo__3y9v4"};